import { Component } from '@angular/core';

@Component({
  selector: 'mac-page-title',
  standalone: false,
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent {}
